import React, { Component } from 'react';
import styles from './PrivacyPolicy.module.css'
import * as cms from '../../shared/repos/cms/cms';
import cmsKeys from '../../shared/constants/cms';
import Loader from '../../components/Loader/Loader';
import CmsInlineEdit from '../../components/Cms/CmsInlineEdit';
import { isBrandRefreshEnabled } from '../../shared/utilities/brandRefresh';
import SecondaryPageEmpty from '../SecondaryPages/SecondaryPageEmpty';


class PrivacyPolicy extends Component {
  constructor(props) {
    super(props);

    this.state = {
          loading: true,
          content: []
      };
  }

  componentDidMount() {
      cms.getContent([cmsKeys.privacyPolicy], this);
  }

  render() {
      const {content, loading} = this.state;

      if (loading) {
          return (
            <div className={styles.pageWrapper} data-region="secondary-page" data-page="PrivacyPolicy">
              <div className={styles.pageContainer} data-part="content-surface">
                <Loader id="loader" />
              </div>
            </div>
          );
      }
    
      if (!content.length && !loading) {
        return (
          <div className={styles.pageWrapper} data-region="secondary-page" data-page="PrivacyPolicy">
            <div className={styles.pageContainer} data-part="content-surface">
              {isBrandRefreshEnabled() ? <SecondaryPageEmpty /> : <h1>Oops, No data found for this page</h1>}
            </div>
          </div>
        );
      }

      return (
        <div className={styles.pageWrapper} data-region="secondary-page" data-page="PrivacyPolicy">
          {content.map(privacyPolicy => {
              return (
                <div className={`${styles.pageContainer} text-dark dark:text-white`} data-part="content-surface">
                  <div className={styles.pageSection} data-part="prose-section">
                    {/* eslint-disable-next-line */}
                    <CmsInlineEdit type="list" cmsNode={privacyPolicy}>
                      {/* eslint-disable-next-line react/no-danger */}
                      <div dangerouslySetInnerHTML={{__html: privacyPolicy.value}} />
                    </CmsInlineEdit>
                  </div>
                </div>
              )
          })}
        </div>
      );
  }
}

export default PrivacyPolicy
